(function () {
    'use strict';

    angular.module('app.completionTypes', [
        'app.core',
        'app.widgets'
    ]);
})();
